import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosPublic from './axiosPublic';

// Check for user (GET)
export const checkForUser = createAsyncThunk('check the user', async () => {
  let response = null;
  try {
    response = await axiosPublic.get('/users/me', {
      headers: { Authorization: `Bearer ${localStorage.getItem('at')}` },
    });
    // console.log(response)
    return response.data
  } catch (error) {
    // console.log('err')
    window.location.href = '/login';
    localStorage.removeItem('at');
    response = error.response;
  }

  return response.data;
});

// forgot password (POST)
export const forgotPassword = createAsyncThunk('forgot password', async (data) => {
  const res = await axiosPublic.post('/auth/forgot-password', { email: data.email, isAdminPanel: true });
  return res.data;
});

// reset password (POST)
export const resetPassword = createAsyncThunk('reset password', async (data) => {
  const res = await axiosPublic.post('/auth/reset-password', {
    email: data.email,
    otp: data.otp,
    newPassword: data.newPassword,
  });
  return res.data;
});

// user login (POST)
export const loginUser = createAsyncThunk('login user', async (data) => {
  let response = null;
  try {
    response = await axiosPublic.post('/auth/login', { email: data.email, password: data.password, isAdminPanel: true });
    console.log('data', response)
    return response.data
  } catch (error) {
    // console.log('err', error)
    response = error.response;
  }
  console.log(response)
  return response.data;
});

// Slice
const eComAuthSlice = createSlice({
  name: 'auth-slice',
  initialState: {
    user: null,
    userLoading: false,
    userError: null,
    userAuthError: null,
  },
  reducers: {
    logout(state) {
      state.user = null;
      state.userError = null;
      state.userAuthError = null;
      localStorage.removeItem('at');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkForUser.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success) {
          state.user = action.payload.data;
          state.userAuthError = null;
        } else {
          state.user = null;
          localStorage.removeItem('at');
          state.userAuthError = action.payload.message || null;
        }
      })

    builder
      .addCase(loginUser.pending, (state) => {
        state.userLoading = true;
        state.userError = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.userLoading = false;
        if (action.payload?.success) {
          state.user = action.payload.data;
          state.userError = null;
          localStorage.setItem('at', action.payload.token);
        } else {
          state.user = null;
          state.userError = action.payload.message;
          localStorage.removeItem('at');
        }
      })

    // Check User
    // builder.addCase(checkForUser.fulfilled, (state, action) => {
    //   state.data.push(action.payload);
    // });

  },
});

export const { logout } = eComAuthSlice.actions;
export default eComAuthSlice.reducer;
